import config from '../config'
import { get } from './http-utils'

const baseUrl = `/api/${config.paymentMethodsPricingServiceUrl}`

export const getPriceInfo = ({
  storeId,
  paymentMethodId,
  channelType,
  amount,
}) =>
  get(
    `${baseUrl}/public/store/${storeId}/payment_methods/${paymentMethodId}/channel_type/${channelType}/price_info?amount=${amount}`,
  )

export const getPriceInfoForBankproduct = ({
  representativeId,
  storeId,
  bankproduct,
  channelType,
  countryCode,
  amount,
  repaymentPeriod,
  interestRate,
}) => {
  const params = new URLSearchParams({
    countryCode,
    amount,
  })

  if (repaymentPeriod) {
    params.append('repayment_months', repaymentPeriod)
  }
  if (interestRate) {
    params.append('interestRate', interestRate)
  }
  return get(
    `${baseUrl}/public/representative/${representativeId}/store/${storeId}/channel_type/${channelType}/bankproduct/${bankproduct}/price_info?${params.toString()}`,
  )
}
